import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';

export default class UpdateTenantFeatureService extends BaseService {
  constructor() {
    super(constants.UPDATE_TENANT_FEATURE_DATA, 'updateTenantFeatureStatus');
  }

  handleEvent(eventName, event) {
    const headers = utils.buildHeadersWithTenantId(event);
    return this.getClient('aiadmin').post(`/aiadmin/tenant/feature/update`, event.payload, { headers });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('tenantFeature').setUpdatedTenantFeature(response);
    const notification = {
      open: true,
      type: 'success',
      message: 'Data Saved successfully'
    };
    Framework.getStoreRegistry().getStore('notificationState').set(notification);
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data) {
        const notification = {
          open: true,
          message: data?.message || 'Error in Updating Features',
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
